module.exports = __webpack_public_path__ + "img/filter-icon.67a9709f.svg";